import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzSpinModule } from 'ng-zorro-antd/spin';

import { ToastModule } from '@libs/src/toast/toast.module';
import { ProfileFormHeadlineModule } from '@main-client/src/app/profile-form-dialogs/profile-form-headline/profile-form-headline.module';

import { ProfileFormDialogHeadlineComponent } from '@main-client/src/app/profile-form-dialogs/profile-form-headline/profile-form-dialog-headline.component';

@NgModule({
  declarations: [ProfileFormDialogHeadlineComponent],
  exports: [ProfileFormDialogHeadlineComponent],
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatButtonModule,
    MatDialogModule,
    NzIconModule,
    NzSpinModule,
    ProfileFormHeadlineModule,
    ToastModule,
  ],
})
export class ProfileFormDialogHeadlineModule {}
